import { formatPeriod } from '@/utils/helpers/format-period';
import { formatPeriodGroup } from '@/utils/helpers/format-period-group';
import { groupPeriodsByConsecutiveDays } from '@/utils/helpers/group-periods-by-consecutive-days';
import { groupPeriodsBySameDate } from '@/utils/helpers/group-periods-by-same-date';

type Period = { start: string; end: string };

type IncidentPeriodGroup = {
  formattedPeriod: string;
};

export const processIncidentPeriods = (periods: Period[], now: Date): IncidentPeriodGroup[] => {
  if (!periods.length) {
    return [];
  }

  const formatted = periods.map((period) => formatPeriod(period, now));
  const dateGroups = groupPeriodsBySameDate(formatted);
  const consecutiveGroups = groupPeriodsByConsecutiveDays(dateGroups);

  return consecutiveGroups.map((group) => ({
    formattedPeriod: formatPeriodGroup(group),
  }));
};
